module.exports = __webpack_public_path__ + "static/undraw_Savings_re_eq4w-78305723160bb51fa4d3175b1904863a.svg";